import React from 'react'
import { SingleColumn } from './New/SingleColumn'
import { TwoColumnsWithAnImage } from './New/TwoColumnsWithAnImage'
import { ThreeColumns } from './New/ThreeColumns'
import { BasicNavLayout } from './New/BasicNavLayout'
import { SingleColumnWithImage } from './New/SingleColumnWIthImage'
import { ArrowRight, ArrowLeft } from 'lucide-react'

const navigationLayouts = {
  single_column: SingleColumn,
  two_columns_with_an_image: TwoColumnsWithAnImage,
  three_columns: ThreeColumns,
  basic_nav_layout: BasicNavLayout,
  single_column_with_image: SingleColumnWithImage,
}

const MobileNavigationItem = item => {
  // @INFO: Check if navigation_sections exist and has items
  const hasNavigationSections =
    item.navigation_sections && item.navigation_sections.length > 0

  const renderNavLayout = (uid, item) => {
    const Component = navigationLayouts[item.component]
    return Component ? <Component key={uid} {...item} /> : null
  }

  return (
    <>
      {hasNavigationSections && (
        <div className="w-full border-b border-dotted border-darkblue">
          <button
            className="text-darkblue font-display flex w-full items-center py-5 px-6 text-xl font-bold leading-5 tracking-[-0.02em] focus:outline-none"
            onClick={() => item.handleNavItemClick(item._uid)}
          >
            <div className="flex items-center justify-between gap-2 w-full">
              <div>{item.label || item.menu_label}</div>
              <div>
                <ArrowRight className="w-5 h-5" />
              </div>
            </div>
          </button>
          <div
            className={`${
              item.scrolled
                ? 'top-[62px] h-[calc(100vh-62px)]'
                : 'top-[96px] h-[calc(100vh-96px)]'
            } bg-lightblue fixed w-screen overflow-y-scroll transition-all duration-300 ${
              item.open ? 'right-0' : '-right-full'
            }`}
          >
            <div className="font-display bg-brightgreen/20 flex flex-row items-center justify-between px-6">
              <button
                className="text-darkblue flex w-full items-center py-6 text-base font-bold leading-4 tracking-[-0.02em] focus:outline-none"
                onClick={() => item.handleNavItemClick(item._uid)}
              >
                <ArrowLeft className="w-5 h-5 mr-2" />
                {item.label || item.menu_label}
              </button>
            </div>
            <div className="grid gap-6 p-4 font-display">
              {renderNavLayout(item._uid, item)}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default MobileNavigationItem
